var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapacitacao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 35.5C24.0938 35.5 28 39.4844 28 44.3281C27.9219 46.3594 26.2812 48 24.25 48H6.75C4.64062 48 3 46.3594 3 44.3281C2.92188 39.4844 6.82812 35.5 11.75 35.5C11.9062 35.5 12.0625 35.5781 12.2969 35.6562C13.3125 35.9688 14.3281 36.125 15.5 36.125C16.5938 36.125 17.6094 35.9688 18.625 35.6562C18.8594 35.5781 19.0156 35.5 19.25 35.5ZM15.5 33C11.2812 33 8 29.7188 8 25.5C8 21.3594 11.2812 18 15.5 18C19.6406 18 23 21.3594 23 25.5C23 29.7188 19.6406 33 15.5 33ZM49.25 8C51.2812 8 53 9.79688 53 11.9062V36.6719C53 38.7812 51.2812 40.5 49.25 40.5H30.1094C29.5625 38.5469 28.4688 36.8281 26.9844 35.5H33V30.5H43V35.5H48V13H20.5V16.9062C19.0156 16.0469 17.2969 15.5 15.5 15.5V11.9062C15.5 9.79688 17.1406 8 19.25 8H49.25Z",
    fill: "#F4731D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapacitacao);
export default __webpack_public_path__ + "static/media/capacitacao.371c3d3d7a9820d966f98b24df0d723c.svg";
export { ForwardRef as ReactComponent };